export const USER_AVATAR_URL = "USER_AVATAR_URL"
export const USER_FIRST_NAME = "USER_FIRST_NAME"
export const USER_LAST_NAME = "USER_LAST_NAME"
export const AUTH_TOKEN_KEY = "AUTH_TOKEN"
export const GRAPHQL_URL = process.env.NODE_ENV === 'production' ? "/graphql" : 'http://localhost:9999/graphql'
